"use strict";

exports.__esModule = true;
exports.default = void 0;
const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'INIT_IMPRINT':
      return state;
    default:
      return state;
  }
};
var _default = exports.default = reducer;
module.exports = exports.default;